interface Category {
  id: string;
  name: string;
  count: number;
}

interface CategoryNavProps {
  categories: Category[];
  selected: string | null;
  onSelect: (categoryId: string | null) => void;
  allLabel: string;
}

export default function CategoryNav({ categories, selected, onSelect, allLabel }: CategoryNavProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={() => onSelect(null)}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
          selected === null
            ? 'bg-primary text-white'
            : 'bg-card border border-primary/20 text-muted-foreground hover:text-foreground hover:border-primary/40'
        }`}
      >
        {allLabel}
      </button>
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onSelect(category.id)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
            selected === category.id
              ? 'bg-primary text-white'
              : 'bg-card border border-primary/20 text-muted-foreground hover:text-foreground hover:border-primary/40'
          }`}
        >
          {category.name}
          <span className="ml-1.5 text-xs opacity-70">({category.count})</span>
        </button>
      ))}
    </div>
  );
}
